import {
  faDownload,
  faFileAlt,
  faPencilAlt,
  faSearch,
  faTag,
  faTrashAlt,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button, B2Form, B2InputGroup, B2Select } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import * as _ from "lodash";
import { FC, createRef, useCallback, useEffect, useRef, useState } from "react";
import { FormControl, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAssetsByLocationAndTypeSlice } from "src/store/slices/dashboard.slice";
import * as yup from "yup";
// import axiosInstance from "../../../../../core/api/axiosClient";
import { toast } from "react-toastify";
import { getLightLocationDashboardSummary } from "../../../../../core/api/services/dashboard.services";
import ModalComponent from "../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../core/components/table/table.component";
import { EquipmentQuantityEnums } from "../../../../../core/enums/health-status-enums";
import HasPermission from "../../../../../core/guards/has-permission";
import FilterFormComponent, {
  FilterFormConfig,
} from "../../../../../shared/filter-form/filter-form.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import TitleComponent from "../../../../../shared/title/title.component";
import { getAssetModels } from "../../../../../store/slices/asset-model.slice";
import {
  getAssetTypes,
} from "../../../../../store/slices/asset-type";
import {
  deleteAsset,
  editAsset,
  exportAssets,
  exportFloorplanLights,
  exportTotalBlocks,
  getAssetSingleAssetByCode,
  getAssetTableSearchStatus,
  getAssetUploadStatus,
  setAssetFilter,
  uploadAssetFile,
} from "../../../../../store/slices/asset.slice";
import { getDriverModels } from "../../../../../store/slices/driver-model.slice";
import { getAllFloorsByBlockCode } from "../../../../../store/slices/floor.slice";
import {
  getBlocksBySiteCode,
  getLocationBlocks,
} from "../../../../../store/slices/location-block.slice";
import { getSiteByTCCode } from "../../../../../store/slices/location-site.slice";
import { getLocationsByBlockAndFloorCode } from "../../../../../store/slices/location.slice";
import { getSLS } from "../../../../../store/slices/sls.slice";
import { getTownCouncils } from "../../../../../store/slices/town-council.slice";
import {
  closeErrorModal,
  closeToaster,
  openErrorModal,
  setComplete,
  setError,
  setFailed,
  setProcessing,
  setUploadMode,
  startUpload,
  updateProgress,
} from "../../../../../store/slices/upload-progress.slice";
import "../../../admin.scss";
import SearchBarComponent from "../../search-bar/search-bar.component";
import "../inventory.scss";
import AssetEditTabComponent from "./asset-edit-tab.component";
import AssetStatisticsSection from "./asset-statistics-section.component";
import { UploadSummary } from "./asset-upload-progress-toaster/upload-progress-toaster.component";
import "./assets.scss";
import {
  getAssets,
  getGatewaySummary,
  getLightSummary,
  getSiteSummaryForBlocks,
} from "src/core/api/services/asset.service";
import { getSiteProjectCategories } from "src/core/api/services/site.service";
import {
  excelFileTypes,
  validateExcelFile,
} from "src/shared/helpers/validate-Files";
import AssetImportModalComponent from "./asset-import-modal.component";
import AssetTaggingModalComponent from "./asset-tagging-modal.component";

interface AssetTableComponentProps {
  columns: any;
  data: any[];
  totalNumberOfRecords: number;
  pageSize: number;
  current: number;
  onChangePage: any;
  onChangeSort: any;
  filter: any;
  onRefetchData: (
    tcCode?: any,
    siteCode?: any,
    blockCode?: any,
    isActive?: any,
    status?: any,
  ) => void;
  isLoading: boolean;
  onSearch: (val: string) => void;
  assetSearchValue: string;
  sortBy: string;
  sortDirection: string;
}

const AssetTableComponent: FC<AssetTableComponentProps> = ({
  columns,
  data,
  totalNumberOfRecords,
  pageSize,
  current,
  onChangePage,
  onChangeSort,
  filter,
  onRefetchData,
  isLoading,
  onSearch,
  assetSearchValue,
  sortBy,
  sortDirection,
}) => {
  const formRef = createRef();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isBlockOptions, setIsBlockOptions] = useState<boolean>(false);
  // const [isSiteOptions, setIsSiteOptions] = useState<boolean>(false);
  const [selectedIdToDeleteOrEdit, setSelectedIdToDeleteOrEdit] =
    useState<number>(0);

  const [equipmentQuantityPageNo, setEquipmentQuantityPageNo] = useState(1);

  const [downloadDocumentPayload, setDownloadDocumentPayload] = useState<any>({
    townCouncil: "",
    site: "",
    block: "",
    status: "",
    assetTypeId: null,
  });

  const [initialModalFilterData, setInitialModalFilterData] = useState<any>({
    townCouncil: "",
    site: "",
    siteOptions: [],
  });

  const [allowTotalBlocksExportWithoutTC, setAllowTotalBlocksExportWithoutTC] =
    useState<boolean>(false);

  const [floorplanLightsPageNumber, setFloorplanLightsPageNumber] =
    useState<number>(1);

  const [floorplanLightsSortBy, setFloorplanLightsSortBy] = useState<any>(
    capitalizeFirst("assetCode"),
  );
  const [floorplanLightsSortDirection, setFloorplanLightsSortDirection] =
    useState<any>("desc");

  const [floorplanLightsColumns, setFloorplanLightsColumns] = useState([
    {
      title: "Asset ID",
      label: "assetCode",
      isSorted: true,
      type: "link",
      link: "/asset",
      linkableField: "assetCode",
      isOpenInNewTable: true,
    },

    {
      title: "Display Name",
      label: "assetDisplayName",
    },
    {
      title: "Serial Number",
      label: "serialNumber",
    },
    {
      title: "Block Code",
      label: "blockCode",
    },
    {
      title: "Floor Code",
      label: "floorCode",
    },
    {
      title: "Display Location Name",
      label: "displayLocationName",
    },
  ]);

  const floorplanLightsHandleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setFloorplanLightsSortBy(sortBy);
      setFloorplanLightsSortDirection(sortDirection);

      const copyColumns: any = await TableSort(floorplanLightsColumns, sortBy);
      setFloorplanLightsColumns(copyColumns);
    },
    [],
  );

  const floorplanLightsHandleChangePage = useCallback((page: number): void => {
    setFloorplanLightsPageNumber(page);
  }, []);

  ///
  const [columnsEquipmentQuantity, setColumnsEquipmentQuantity] = useState([
    {
      title: "Asset ID",
      label: "assetId",
      type: "link",
      link: "/asset",
      linkableField: "assetId",
      isSorted: true,
      isOpenInNewTable: true,
    },
    {
      title: "Display Name",
      label: "sensorDisplayName",
    },
    {
      title: "Address",
      label: "address",
    },
    {
      title: "Status",
      label: "status",
    },
  ]);

  const [columnsForLuminaireQuantity] = useState([
    {
      title: "Asset ID",
      label: "assetId",
      type: "link",
      link: "/asset",
      linkableField: "assetId",
      isSorted: true,
      isOpenInNewTable: true,
    },
    {
      title: "Display Name",
      label: "sensorDisplayName",
    },
    {
      title: "Address",
      label: "address",
    },
  ]);

  const [updateForm, setUpdateForm] = useState(0);

  /*   const [initialValues, setInitialValues] = useState<any>({
      assetCode: "",
      assetModelCode: "",
      parentAssetCode: "",
      driverModelCode: "",
      blockCode: "",
      floorCode: "",
      lightTypeId: 0,
      assetTypeId: 0,
      registrationDate: "",
      isActive: false,
      blockSubLocationId: 0,
      supplierId: 0,
      serialNumber: "",
      sensorDisplayName: "",
      sensorMaintenanceCompany: "",
      isPhotoSensor: false,
      isMotionSensor: false,
      isRainSensor: false,
      isTemparatureSensor: false,
      xcoord: 0.0,
      ycoord: 0.0,
      zcoord: 0.0,
      latitude: 0.0,
      longitude: 0.0,
      deploymentTypeId: 0,
      unit: "",
      sensorCoverage: "",
      powerConsumption: "",
      powerSource: "",
      networkConnectivity: "",
      networkconnectivityProvider: "",
      connectivityContractExpiry: null,
      dataCollectionMode: "",
      dataTransmissionMode: "",
      bandwidth: "",
      dataUsagePerMonth: "",
      availability: "",
      compassBearing: "",
      resiliency: "",
      security: "",
      quantityPerLocation: 1,
      lightPower: 0,
    }); */

  const [tcOptions, setTCOptions] = useState<any>([]);
  const [
    tcOptionsForTotalLightsFloorplan,
    setTCOptionsForTotalLightsFloorplan,
  ] = useState<any>([]);
  // const [locationOptions, setLocationOptions] = useState<any>([]);
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const [modalSiteOptions, setModalSiteOptions] = useState<any>([]);
  const [blockOptions, setBlockOptions] = useState<any>([]);
  // const [levelOptions, setLevelOptions] = useState<any>([]);
  // const [floorToLocationOptions, setFloorToLocationOptions] = useState<any>([]);
  // const [driverModelOptions, setDriverModelOptions] = useState<any>([]);
  const [assetTypeOptions, setAssetTypeOptions] = useState<any>([]);
  // const [slsSupplierOptions, setSlsSupplierOptions] = useState<any>([]);
  // const [luminaryModelOptions, setLuminaryModelOptions] = useState<any>([]);
  // const [progress, setProgress] = useState<number>(0);
  // const [showProgressModal, setShowProgressModal] = useState<boolean>(false);
  // Upload progress state now managed by Redux - keeping these for backward compatibility
  const uploadState = useSelector((state: any) => state.uploadProgress);
  // const uploadJobId = uploadState.jobId;
  const abortControllerRef = useRef<AbortController | null>(null);
  const [isSubmitedFilter, setIsSubmitedFilter] = useState(1);

  // Import modal states
  const [showImportModal, setShowImportModal] = useState<boolean>(false);
  const [showAssetTaggingModal, setShowAssetTaggingModal] = useState<boolean>(false);
  const [importedFile, setImportedFile] = useState<File | null>(null);
  const [importType, setImportType] = useState<"complete" | "incremental">(
    "incremental",
  );

  const [isEquipmentQuantityModalOpen, setIsEquipmentQuantityModalOpen] =
    useState<boolean>(false);

  const [isTotalBlocksModalOpen, setIsTotalBlocksModalOpen] =
    useState<boolean>(false);

  const [isTotalLightsFloorplanModalOpen, setIsTotalLightsFloorplanModalOpen] =
    useState<boolean>(false);

  // Total Blocks Modal States
  const [totalBlocksPageNumber, setTotalBlocksPageNumber] = useState<number>(1);
  const [totalBlocksSortBy, setTotalBlocksSortBy] = useState<any>(
    capitalizeFirst("tcName"),
  );
  const [totalBlocksSortDirection, setTotalBlocksSortDirection] =
    useState<any>("desc");
  const [totalBlocksColumns, setTotalBlocksColumns] = useState([
    {
      title: "Town Council",
      label: "tcName",
      isSorted: true,
    },
    {
      title: "Site",
      label: "siteName",
    },
    {
      title: "Total Blocks",
      label: "totalBlocks",
    },
    {
      title: "Blocks",
      label: "blocks",
    },
    {
      title: "Assets",
      label: "assetCount",
    },
    {
      title: "Category",
      label: "siteProjectType",
    },
  ]);
  const [projectCategoryOptions, setProjectCategoryOptions] = useState<any>([]);
  const [totalBlocksProjectCategory, setTotalBlocksProjectCategory] =
    useState<string>("");

  const totalBlocksHandleChangePage = useCallback((page: number): void => {
    setTotalBlocksPageNumber(page);
  }, []);

  const totalBlocksHandleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setTotalBlocksSortBy(sortBy);
      setTotalBlocksSortDirection(sortDirection);

      const copyColumns: any = await TableSort(totalBlocksColumns, sortBy);
      setTotalBlocksColumns(copyColumns);
    },
    [totalBlocksColumns],
  );

  const [selectedEquipmentQuantityType, setSelectedEquipmentQuantityType] =
    useState<number>(2);
  const [selectedTcCode, setSelectedTcCode] = useState(null);
  const [selectedSiteCode, setSelectedSiteCode] = useState(null);
  const [selectedBlockCode, setSelectedBlockCode] = useState(null);
  const [selectedAssetTypeId, setSelectedAssetTypeId] = useState(null);
  const [floorplanStatus, setFloorplanStatus] = useState("OutFloorPlan");
  const [modalTownCouncil, setModalTownCouncil] = useState<string>("");
  const [modalTownCouncilError, setModalTownCouncilError] =
    useState<string>("");
  const [modalSite, setModalSite] = useState<string>("");

  const [equipmentQuantitySortDirection, setEquipmentQuantitySortDirection] =
    useState<any>("desc");
  const [equipmentQuantitySortBy, setEquipmentQuantitySortBy] = useState<any>(
    capitalizeFirst("assetId"),
  );

  const equipmentQuantityModalSearchedData = useSelector((state: any) => {
    return state.dashboard.equipmentQuantityModalData;
  });

  const isLoadingEquipmentQuantityModalData = useSelector((state: any) => {
    return state.dashboard.isLoadingEquipmentQuantityModalData;
  });

  const isLoadingAssetExport = useSelector((state: any) => {
    return state.asset.isLoadingAssetExport;
  });

  const isLoadingBlocksExport = useSelector((state: any) => {
    return state.asset.isLoadingBlocksExport;
  });

  const [modalTitle, setModalTitle] = useState<string>("");

  const onlineOfflineOptions = [
    {
      label: "Online",
      value: "online",
    },
    {
      label: "Offline",
      value: "offline",
    },
    {
      label: "Never Connected",
      value: "neverConnected",
    },
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTownCouncils({ PageNumber: 0, pageSize: 0 }));
  }, [dispatch]);

  const townCouncilData = useSelector((state: any) => {
    return state.townCouncil.townCouncils;
  });

  const isLoadingTownCouncils = useSelector((state: any) => {
    return state.townCouncil.isLoadingTownCouncils;
  });

  /*   const locationData = useSelector((state: any) => {
      return state.locationBlock.locationBlocks;
    }); */

  /*   const floorLocationData = useSelector((state: any) => {
      return state.floorLocation.floorLocations;
    }); */

  const isLoadingBlocksBySiteCode = useSelector((state: any) => {
    return state.locationBlock.isLoadingBlocksBySiteCode;
  });

  const siteDataByTCCode = useSelector((state: any) => {
    return state.locationSite.sitesByTCCode;
  });

  const isLocationSitesByTCCode = useSelector((state: any) => {
    return state.locationSite.isLocationSitesByTCCode;
  });

  const blockDataSiteCode = useSelector((state: any) => {
    return state.locationBlock.blocksBySiteCode;
  });

  /*   const floorResponse = useSelector((state: any) => {
      return state.floor.floorByBlockCode;
    }); */

  /*   const driverModelResponse = useSelector((state: any) => {
      return state.driverModel.driverModels;
    }); */

  const allAssetTypeResponse = useSelector((state: any) => {
    return state.assetType.assetTypes;
  });

  /*   const slsSupplierResponse = useSelector((state: any) => {
      return state.sls.sls;
    }); */

  /*   const assetModelsResponse = useSelector((state: any) => {
      return state.assetModel.assetModels;
    }); */

  // const selectedItems = useSelector((state: any) => state.table.selectedItems);

  let floorplanStatusFilter: any = null;

  if (floorplanStatus === "InFloorPlan") {
    floorplanStatusFilter = true;
  } else if (floorplanStatus === "OutFloorPlan") {
    floorplanStatusFilter = false;
  }

  const {
    data: floorplanLightsAssets,
    isLoading: isLoadingfloorplanLightsAssets,
  } = useQuery({
    queryKey: [
      "getAssets",
      floorplanLightsPageNumber,
      filter?.townCouncil,
      filter?.site,
      filter?.block,
      filter?.isActive,
      filter?.status,
      filter?.assetTypeId,
      floorplanLightsSortBy,
      floorplanLightsSortDirection,
      null,
      floorplanStatus,
      modalTownCouncil,
      modalSite,
    ],
    queryFn: ({ signal }) =>
      getAssets(
        floorplanLightsPageNumber,
        pageSize,
        isTotalLightsFloorplanModalOpen
          ? modalTownCouncil
          : filter?.townCouncil,
        isTotalLightsFloorplanModalOpen ? modalSite : filter?.site,
        isTotalLightsFloorplanModalOpen ? null : filter?.block,
        isTotalLightsFloorplanModalOpen ? null : filter?.isActive,
        isTotalLightsFloorplanModalOpen ? null : filter?.status,
        isTotalLightsFloorplanModalOpen ? null : filter?.assetTypeId,
        floorplanLightsSortBy,
        floorplanLightsSortDirection,
        null,
        signal,
        floorplanStatusFilter,
      ),
    enabled: isTotalLightsFloorplanModalOpen,
    // enabled: floorplanStatus ==="InFloorPlan" ? true : false,
  });

  const { data: totalBlocksData, isLoading: isLoadingTotalBlocks } = useQuery({
    queryKey: [
      "getSiteSummaryForBlocks",
      totalBlocksPageNumber,
      modalTownCouncil,
      modalSite,
      totalBlocksProjectCategory,
      totalBlocksSortBy,
      totalBlocksSortDirection,
    ],
    queryFn: ({ signal }) =>
      getSiteSummaryForBlocks(
        totalBlocksPageNumber,
        pageSize,
        modalTownCouncil || null,
        modalSite || null,
        totalBlocksProjectCategory || null,
        totalBlocksSortBy,
        totalBlocksSortDirection,
        signal,
      ),
    enabled: isTotalBlocksModalOpen,
  });

  let { data: projectCategoryResponse } = useQuery({
    queryKey: ["getSiteProjectCategories"],
    queryFn: ({ signal }) => getSiteProjectCategories(signal),
  });

  const {
    data: lightLocationDashboardSummary,
    isLoading: isLoadingLightLocationDashboardSummary,
    refetch: refetchLightLocationDashboardSummary,
  } = useQuery({
    queryKey: [
      "getLightLocationDashboardSummary",
      selectedTcCode,
      selectedSiteCode,
      selectedBlockCode,
      isSubmitedFilter,
    ],
    queryFn: ({ signal }) =>
      getLightLocationDashboardSummary(
        selectedTcCode,
        signal,
        selectedSiteCode,
        selectedBlockCode,
      ),
  });

  const {
    data: gatewaySummary,
    isLoading: isLoadingGatewaySummary,
    refetch: refetchGatewaySummary,
  } = useQuery({
    queryKey: [
      "gatewaySummary",
      selectedTcCode,
      selectedSiteCode,
      selectedBlockCode,
      isSubmitedFilter,
    ],
    queryFn: ({ signal }) =>
      getGatewaySummary(
        selectedTcCode,
        selectedSiteCode,
        selectedBlockCode,
        signal,
      ),
  });

  const {
    data: lightSummary,
    isLoading: isLoadingLightSummary,
    refetch: refetchLightSummary,
  } = useQuery({
    queryKey: [
      "lightSummary",
      selectedTcCode,
      selectedSiteCode,
      selectedBlockCode,
      isSubmitedFilter,
    ],
    queryFn: ({ signal }) =>
      getLightSummary(
        selectedTcCode,
        selectedSiteCode,
        selectedBlockCode,
        signal,
      ),
  });

  const healthStatusModalHandler = (title: any, type: string) => {
    // Only open equipment-quantity modal for supported types (luminaire/gateway).
    if (type === "quantity") {
      if (
        title === EquipmentQuantityEnums.LUMINARY_QUANTITY ||
        title === EquipmentQuantityEnums.GATEWAY_QUANTITY
      ) {
        setIsEquipmentQuantityModalOpen(true);
      }
    }

    if (type === "TotalBlocks") {
      const townCouncil =
        initialModalFilterData?.townCouncil || selectedTcCode || "";
      const site = initialModalFilterData?.site || selectedSiteCode || "";
      const totalBlocksSiteOptions =
        (initialModalFilterData?.siteOptions &&
          initialModalFilterData.siteOptions.length > 0
          ? initialModalFilterData.siteOptions
          : siteOptions) || [];

      setIsTotalBlocksModalOpen(true);
      setModalTownCouncilError("");
      setModalTownCouncil(townCouncil);
      setModalSiteOptions(totalBlocksSiteOptions);
      setModalSite(site);
      setAllowTotalBlocksExportWithoutTC(true);
      setTotalBlocksPageNumber(1);
      setTotalBlocksSortBy(capitalizeFirst("tcName"));
      setTotalBlocksSortDirection("desc");
    }

    if (type === "TotalLightsFloorplan") {
      const townCouncil =
        initialModalFilterData?.townCouncil || selectedTcCode || "";
      const site = initialModalFilterData?.site || selectedSiteCode || "";
      const totalLightsFloorplanSiteOptions =
        (initialModalFilterData?.siteOptions &&
          initialModalFilterData.siteOptions.length > 0
          ? initialModalFilterData.siteOptions
          : siteOptions) || [];

      setIsTotalLightsFloorplanModalOpen(true);
      setModalTownCouncilError("");
      setFloorplanStatus("OutFloorPlan");
      setModalTownCouncil(townCouncil);
      setModalSiteOptions(totalLightsFloorplanSiteOptions);
      setModalSite(site);
      setFloorplanLightsPageNumber(1);
      setFloorplanLightsSortBy(capitalizeFirst("assetCode"));
      setFloorplanLightsSortDirection("desc");
    }

    if (title === EquipmentQuantityEnums.LUMINARY_QUANTITY) {
      setModalTitle("Luminaire Quantity");
      setSelectedEquipmentQuantityType(2);
    } else if (title === EquipmentQuantityEnums.GATEWAY_QUANTITY) {
      setModalTitle("Gateway Quantity");
      setSelectedEquipmentQuantityType(3);
    }
  };

  /* useEffect(() => {
    const driverModels = driverModelResponse?.data?.map((dm: any) => ({
      label: dm?.driverModelCode,
      value: dm?.driverModelCode,
    }));

    setDriverModelOptions(driverModels);
  }, [driverModelResponse]); */

  useEffect(() => {
    const assetTypes = allAssetTypeResponse?.data?.map((assetType: any) => ({
      label: assetType?.name,
      value: assetType?.id,
    }));

    setAssetTypeOptions(assetTypes);
  }, [allAssetTypeResponse]);

  /*   useEffect(() => {
      const sls = slsSupplierResponse?.data?.map((sls: any) => ({
        label: sls?.name,
        value: sls?.id,
      }));
  
      setSlsSupplierOptions(sls);
    }, [slsSupplierResponse]); */

  /*   useEffect(() => {
      const assetModels = assetModelsResponse?.data?.map((asset: any) => ({
        label: asset?.assetModelCode,
        value: asset?.assetModelCode,
      }));
  
      setLuminaryModelOptions(assetModels);
    }, [assetModelsResponse]); */

  useEffect(() => {
    const projectCategories = projectCategoryResponse?.data?.map((pc: any) => ({
      label: pc?.name,
      value: pc?.id.toString(),
    }));

    setProjectCategoryOptions(projectCategories);
  }, [projectCategoryResponse]);

  /*   useEffect(() => {
      const floors = floorResponse?.data?.map((floor: any) => ({
        label: floor?.displayLevel,
        value: floor?.displayLevel,
      }));
  
      setLevelOptions(floors);
    }, [floorResponse]); */

  const [currentTC, setCurrentTC] = useState({ label: "", value: "" });

  useEffect(() => {
    const tcs = townCouncilData?.data?.map((tc: any) => ({
      label: tc?.name,
      value: tc?.tcCode,
    }));

    // if user is TC Admin only 1 tc is available
    if (tcs?.length === 1) {
      setCurrentTC(tcs[0]);
    }

    setTCOptions(tcs);
    setTCOptionsForTotalLightsFloorplan(tcs);
    setFilterUpdateCount(filterUpdateCount + 1);
  }, [townCouncilData]);

  useEffect(() => {
    if (currentTC?.value?.length) {
      setFormFilterInitialValues((prev) => ({
        ...prev,
        townCouncil: currentTC?.value,
      }));

      dispatch(getSiteByTCCode({ tcCode: currentTC?.value }));
    }
  }, [currentTC]);

  /*   useEffect(() => {
      const blocks = locationData?.data?.map((block: any) => ({
        label: block?.blockName,
        value: block?.blockCode,
      }));
  
      setLocationOptions(blocks);
    }, [locationData]); */

  /*   useEffect(() => {
      const floorLocations = floorLocationData?.data?.map((location: any) => ({
        label: location?.name,
        value: location?.id,
      }));
  
      setFloorToLocationOptions(floorLocations);
    }, [floorLocationData]); */

  useEffect(() => {
    // if (!isSiteOptions) return;

    if (isTotalBlocksModalOpen || isTotalLightsFloorplanModalOpen) return;

    const sites = siteDataByTCCode?.data?.map((site: any) => ({
      label: site?.name,
      value: site?.siteCode,
    }));

    if (!sites?.length) return;

    setSiteOptions(sites);
  }, [siteDataByTCCode]);

  useEffect(() => {
    if (!isBlockOptions!) return;

    const blocks = blockDataSiteCode?.data?.map((block: any) => ({
      label: block?.blockName,
      value: block?.blockCode,
    }));

    setBlockOptions(blocks);
  }, [blockDataSiteCode, isBlockOptions]);

  const onChangeTC = (selectedTC: any) => {
    setSiteOptions([]);
    setBlockOptions([]);
    setSelectedTcCode(selectedTC);
    setSelectedSiteCode(null);
    setSelectedBlockCode(null);

    const form: any = formRef.current;

    const status = form.values.status;
    form.setFieldValue("site", "");
    form.setFieldValue("block", "");

    if (!selectedTC) return;

    setFormFilterInitialValues((initval: any) => {
      return {
        ...initval,
        townCouncil: selectedTC || "",
        site: "",
        block: "",
        status: status,
        assetTypeId: selectedAssetTypeId,
      };
    });

    dispatch(getSiteByTCCode({ tcCode: selectedTC }));
    setIsBlockOptions(false);
    // setIsSiteOptions(true);
  };

  const onChangeSite = (selectedSite: any) => {
    setBlockOptions([]);
    setSelectedSiteCode(selectedSite);
    setSelectedBlockCode(null);

    const form: any = formRef.current;

    const status = form.values.status;
    form.setFieldValue("block", "");

    if (!selectedSite) return;

    setFormFilterInitialValues((initval: any) => {
      return {
        ...initval,
        site: selectedSite || "",
        block: "",
        status: status,
        assetTypeId: selectedAssetTypeId,
      };
    });

    dispatch(getBlocksBySiteCode({ siteCode: selectedSite }));
    setIsBlockOptions(true);
  };

  const onChangeBlock = (selectedBlock: any) => {
    setSelectedBlockCode(selectedBlock);
  };

  const onChangeAssetType = (selectedAssetType: any) => {
    setSelectedAssetTypeId(selectedAssetType);
  };

  const onSubmitFilter = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();
      const { townCouncil, site, block, status } = form?.values || {};

      if (!townCouncil) return;

      setDownloadDocumentPayload({
        townCouncil,
        site,
        block,
        status,
        assetTypeId: selectedAssetTypeId,
      });

      dispatch(setAssetFilter(form?.values));
      setIsSubmitedFilter((prev: any) => prev + 1);
    }
  };

  const onClickFloorplanLightsExport = () => {
    if (!modalTownCouncil) {
      toast.warning("Please select Town Council first to Export", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
      });

      setModalTownCouncilError("Town Council is required");
      return;
    }

    dispatch(
      exportFloorplanLights({
        tcCode: modalTownCouncil || null,
        siteCode: modalSite || null,
        isInFloorPlan: floorplanStatus === "InFloorPlan",
        sortBy: sortBy,
        sortDirection: sortDirection,
      }),
    );
  };

  const onClickTotalBlocksExport = () => {
    if (!modalTownCouncil && !allowTotalBlocksExportWithoutTC) {
      toast.warning("Please select Town Council first to Export", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
      });

      setModalTownCouncilError("Town Council is required");
      return;
    }

    dispatch(
      exportTotalBlocks({
        tcCode: modalTownCouncil || null,
        siteCode: modalSite || null,
        siteProjectTypeId: totalBlocksProjectCategory || null,
        sortBy: totalBlocksSortBy,
        sortDirection: totalBlocksSortDirection,
      }),
    );
  };

  const onSubmitFilterForModals = async () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();
      const { townCouncil, site } = form?.values || {};

      if (!townCouncil) return;

      try {
        const siteOptions =
          await getSiteOptionsForTotalLightsFloorPlan(townCouncil);

        // Update modal filter state
        setInitialModalFilterData({
          townCouncil,
          site,
          siteOptions,
        });
      } catch (error) {
        console.error("Error in filter submission:", error);
        // Handle error appropriately
      }
    }
  };

  const getSiteOptionsForTotalLightsFloorPlan = async (tcCode: string) => {
    if (!tcCode) {
      return [];
    }

    try {
      const result = await dispatch(getSiteByTCCode({ tcCode }));
      const sites = result?.payload?.data?.map((site: any) => ({
        label: site?.name,
        value: site?.siteCode,
      }));
      return sites || [];
    } catch (error) {
      console.error("Error fetching sites:", error);
      return [];
    }
  };

  const handleFloorplanFilterChange = async (
    fieldName: string,
    selectedOption: any,
    event: any,
  ) => {
    const value = selectedOption?.value || "";

    switch (fieldName) {
      case "townCouncilStatus": {
        setModalTownCouncil(value);
        setModalTownCouncilError("");
        setModalSite("");
        setModalSiteOptions([]);
        setFloorplanLightsPageNumber(1);

        // Fetch site options using the new function
        const sites = await getSiteOptionsForTotalLightsFloorPlan(value);
        setModalSiteOptions(sites);
        break;
      }

      case "siteStatus":
        setModalSite(value);
        setFloorplanLightsPageNumber(1);
        break;

      case "floorplanStatus":
        setFloorplanStatus(value);
        setFloorplanLightsPageNumber(1);
        break;

      default:
        break;
    }
  };

  const handleTotalBlocksFilterChange = async (
    fieldName: string,
    selectedOption: any,
    event: any,
  ) => {
    const value = selectedOption?.value || "";

    switch (fieldName) {
      case "totalBlocksTCStatus": {
        setModalTownCouncil(value);
        setModalTownCouncilError("");
        setModalSite("");
        setModalSiteOptions([]);
        setTotalBlocksPageNumber(1);

        // Fetch site options
        const sites = await getSiteOptionsForTotalLightsFloorPlan(value);
        setModalSiteOptions(sites);
        break;
      }

      case "totalBlocksSiteStatus":
        setModalSite(value);
        setTotalBlocksPageNumber(1);
        break;

      case "totalBlocksProjectCategory":
        setTotalBlocksProjectCategory(value);
        setTotalBlocksPageNumber(1);
        break;

      default:
        break;
    }
  };

  const onClickExport = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();
      let { townCouncil, site, block, status } = downloadDocumentPayload;

      if (!townCouncil) {
        toast.warning("Please filter first then Export", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
        });

        return;
      } else if (
        (selectedTcCode && townCouncil && selectedTcCode != townCouncil) ||
        (selectedSiteCode && site && selectedSiteCode != site) ||
        (selectedBlockCode && block && selectedBlockCode != block)
      ) {
        toast.warning("Please filter with the new selections first", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
        });

        return;
      }

      dispatch(
        exportAssets({
          tcCode: townCouncil || null,
          siteCode: site || null,
          blockCode: block || null,
          assetTypeId: selectedAssetTypeId || null,
          isActive: false,
          status: status || null,
          searchText: assetSearchValue,
          sortBy: sortBy,
          sortDirection: sortDirection,
        }),
      );
    }
  };

  const onReset = () => {
    const form: any = formRef.current;
    form.resetForm();

    setFilterUpdateCount(filterUpdateCount + 1);

    setFormFilterInitialValues({
      townCouncil: "",
      site: "",
      block: "",
      status: "",
      assetTypeId: null,
    });

    setDownloadDocumentPayload({
      townCouncil: "",
      site: "",
      block: "",
      status: "",
      assetTypeId: null,
    });

    setInitialModalFilterData({
      townCouncil: "",
      site: "",
      siteOptions: [],
    });

    dispatch(setAssetFilter({}));
    setSiteOptions([]);
    setBlockOptions([]);
    setSelectedAssetTypeId(null);

    // setIsSiteOptions(false);
    setIsBlockOptions(false);
    setSelectedTcCode(null);
    setSelectedSiteCode(null);
    setSelectedBlockCode(null);
    setIsSubmitedFilter((prev: any) => prev + 1);
  };

  const assetDetails = useSelector((state: any) => {
    return state.asset.assetDetailsData;
  });

  const isLoadingAssetDetailsData = useSelector((state: any) => {
    return state.asset.isLoadingAssetDetailsData;
  });

  const handleCloseModal = (isRefetchRequired: boolean) => {
    setIsModalOpen(false);
    dispatch(closeErrorModal());
    setIsEdit(false);
    setIsDetails(false);
    setIsDelete(false);
    setIsTotalBlocksModalOpen(false);

    setIsEquipmentQuantityModalOpen(false);
    setIsTotalLightsFloorplanModalOpen(false);
    setFloorplanStatus("");
    setModalTownCouncil("");
    setModalTownCouncilError("");
    setModalSite("");
    setModalSiteOptions([]);
    setFloorplanLightsPageNumber(1);
    setFloorplanLightsSortBy(capitalizeFirst("assetCode"));
    setFloorplanLightsSortDirection("desc");
    setEquipmentQuantityPageNo(1);

    // Reset Total Blocks modal state
    setTotalBlocksProjectCategory("");
    setTotalBlocksPageNumber(1);
    setTotalBlocksSortBy(capitalizeFirst("tcName"));
    setTotalBlocksSortDirection("desc");
    setAllowTotalBlocksExportWithoutTC(false);

    /* setInitialValues({
      assetCode: "",
      assetModelCode: "",
      parentAssetCode: "",
      driverModelCode: "",
      blockCode: "",
      floorCode: "",
      lightTypeId: 0,
      assetTypeId: 0,
      registrationDate: "",
      isActive: false,
      blockSubLocationId: 0,
      supplierId: 0,
      serialNumber: "",
      sensorDisplayName: "",
      sensorMaintenanceCompany: "",
      isPhotoSensor: false,
      isMotionSensor: false,
      isRainSensor: false,
      isTemparatureSensor: false,
      xcoord: 0.0,
      ycoord: 0.0,
      zcoord: 0.0,
      latitude: 0.0,
      longitude: 0.0,
      deploymentTypeId: 0,
      unit: "",
      sensorCoverage: "",
      powerConsumption: "",
      powerSource: "",
      networkConnectivity: "",
      networkconnectivityProvider: "",
      connectivityContractExpiry: null,
      dataCollectionMode: "",
      dataTransmissionMode: "",
      bandwidth: "",
      dataUsagePerMonth: "",
      availability: "",
      compassBearing: "",
      resiliency: "",
      security: "",
      quantityPerLocation: 1,
      lightPower: 0,
    }); */

    delayedSearchRef?.current?.cancel?.();
    setSearchValue("");

    if (isRefetchRequired) {
      void refetchGatewaySummary();
      void refetchLightSummary();
      void refetchLightLocationDashboardSummary();
    }
  };

  const editAction = (id: any) => {
    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(true);
    setIsDelete(false);

    dispatch(getAssetSingleAssetByCode({ assetCode: id }))
      .then((response: any) =>
        Promise.all([
          dispatch(
            getAllFloorsByBlockCode({
              blockCode: response?.payload?.blockCode,
            }),
          ),
          dispatch(
            getLocationsByBlockAndFloorCode({ PageNumber: 0, PageSize: 0 }),
          ),
          dispatch(getLocationBlocks({ PageNumber: 0, pageSize: 0 })),
          dispatch(getDriverModels({ PageNumber: 0, pageSize: 0 })),
          dispatch(getAssetTypes({ PageNumber: 0, pageSize: 0 })),
          // dispatch(getAllAssetTypes()),
          dispatch(getSLS({ PageNumber: 0, pageSize: 0 })),
          dispatch(getAssetModels({ PageNumber: 0, pageSize: 0 })),
        ]),
      )
      .catch((error: any) => {
        console.log("Error in api call: ", error);
      });

    setSelectedIdToDeleteOrEdit(id);
  };

  const detailsAction = (id: any) => {
    setIsDetails(true);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(false);

    dispatch(getAssetSingleAssetByCode({ assetCode: id }))
      .then((response: any) =>
        Promise.all([
          dispatch(
            getAllFloorsByBlockCode({
              blockCode: response[0].payload.blockCode,
            }),
          ),
          dispatch(
            getLocationsByBlockAndFloorCode({ PageNumber: 0, PageSize: 0 }),
          ),
          dispatch(getLocationBlocks({ PageNumber: 0, pageSize: 0 })),
          dispatch(getDriverModels({ PageNumber: 0, pageSize: 0 })),
          dispatch(getAssetTypes({ PageNumber: 0, pageSize: 0 })),
          // dispatch(getAllAssetTypes()),
          dispatch(getSLS({ PageNumber: 0, pageSize: 0 })),
          dispatch(getAssetModels({ PageNumber: 0, pageSize: 0 })),
        ]),
      )
      .catch((error: any) => {
        console.log("Error in api call: ", error);
      });
  };

  const deleteAction = (assetCode: any) => {
    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(true);

    setSelectedIdToDeleteOrEdit(assetCode);
  };

  const handleDelete = () => {
    dispatch(deleteAsset({ assetCode: selectedIdToDeleteOrEdit })).then(() => {
      onRefetchData();
      handleCloseModal(true);
    });
  };

  useEffect(() => {
    if (!assetDetails || !Object.keys(assetDetails).length) return;

    /* setInitialValues({
      assetCode: assetDetails?.assetCode || "",
      assetModelCode: assetDetails?.assetModelCode || "",
      parentAssetCode: assetDetails?.parentAssetCode || "",
      driverModelCode: assetDetails?.driverModelCode || "",
      blockCode: assetDetails?.blockCode || "",
      floorCode: assetDetails?.floorCode || "",
      displayLocationId: assetDetails?.displayLocationId || "",
      lightTypeId: assetDetails?.lightTypeId || 0,
      assetTypeId: assetDetails?.assetTypeId || 0,
      registrationDate: assetDetails?.registrationDate || "",
      isActive: assetDetails?.isActive || false,
      blockSubLocationId: assetDetails?.blockSubLocationId || 0,
      supplierId: assetDetails?.supplierId || 0,
      serialNumber: assetDetails?.serialNumber || "",
      sensorDisplayName: assetDetails?.sensorDisplayName || "",
      sensorMaintenanceCompany: assetDetails?.sensorMaintenanceCompany || "",
      isPhotoSensor: assetDetails?.isPhotoSensor || false,
      isMotionSensor: assetDetails?.isMotionSensor || false,
      isRainSensor: assetDetails?.isRainSensor || false,
      isTemparatureSensor: assetDetails?.isTemparatureSensor || false,
      xcoord: assetDetails?.xcoord || 0.0,
      ycoord: assetDetails?.ycoord || 0.0,
      zcoord: assetDetails?.zcoord || 0.0,
      latitude: parseFloat(assetDetails?.latitude).toFixed(2) || 0.0,
      longitude: parseFloat(assetDetails?.longitude).toFixed(2) || 0.0,
      deploymentTypeId: assetDetails?.deploymentTypeId || 0,
      unit: assetDetails?.unit || "",
      sensorCoverage: assetDetails?.sensorCoverage || "",
      powerConsumption: assetDetails?.powerConsumption || "",
      powerSource: assetDetails?.powerSource || "",
      networkConnectivity: assetDetails?.networkConnectivity || "",
      networkconnectivityProvider:
        assetDetails?.networkconnectivityProvider || "",
      connectivityContractExpiry:
        assetDetails?.connectivityContractExpiry || null,
      dataCollectionMode: assetDetails?.dataCollectionMode || "",
      dataTransmissionMode: assetDetails?.dataTransmissionMode || "",
      bandwidth: assetDetails?.bandwidth || "",
      dataUsagePerMonth: assetDetails?.dataUsagePerMonth || "",
      availability: assetDetails?.availability || "",
      compassBearing: assetDetails?.compassBearing || "",
      resiliency: assetDetails?.resiliency || "",
      security: assetDetails?.security || "",
      quantityPerLocation: assetDetails?.quantityPerLocation || 1,
      lightPower: assetDetails?.lightPower || 0,
    }); */

    setUpdateForm(updateForm + 1);
  }, [assetDetails]);

  const onSubmit = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();

      const { blockCode, floorCode } = form.values;

      if (!blockCode || !floorCode) return;

      const formValues = form.values;

      const payload = {
        ...formValues,
        displayLocationId: Number.parseInt(formValues?.displayLocationId) ?? null,
        assetCode: selectedIdToDeleteOrEdit,
      };

      dispatch(
        editAsset({
          payload,
          assetCode: selectedIdToDeleteOrEdit,
        }),
      ).then(() => {
        handleCloseModal(true);
        onRefetchData();
      });
    }
  };

  const [formFilterInitialValues, setFormFilterInitialValues] = useState({
    townCouncil: filter?.townCouncil || "",
    site: filter?.site || "",
    block: filter?.block || "",
    // isActive: filter?.isActive || "",
    status: filter?.status || "",
    assetTypeId: filter?.assetTypeId || null,
  });

  useEffect(() => {
    setSiteOptions([]);
    setBlockOptions([]);

    if (filter?.townCouncil) {
      dispatch(getSiteByTCCode({ tcCode: filter.townCouncil }));
      setIsBlockOptions(false);
      // setIsSiteOptions(true);
    }
    if (filter?.townCouncil && filter?.site) {
      dispatch(getBlocksBySiteCode({ siteCode: filter.site }));
      setIsBlockOptions(true);
    }
    // dispatch(getAllAssetTypes());
    dispatch(getAssetTypes({ PageNumber: 0, pageSize: 0 }));
  }, []);

  let modalActionConfig: any = [];

  if (isDelete) {
    modalActionConfig = [
      {
        label: "Yes",
        event: handleDelete,
        variant: "primary",
      },
    ];
  } else if (!isDetails) {
    modalActionConfig = [
      {
        label: "Save",
        event: onSubmit,
        variant: "primary",
      },
    ];
  }

  const filterActionConfig: any = {
    label: "Filter",
    event: async () => {
      onSubmitFilter();
      await onSubmitFilterForModals();
    },
    variant: "primary",
  };

  const reset: any = {
    label: "Reset",
    event: onReset,
    variant: "secondary",
  };

  const actionConfig: any = [
    {
      label: "Edit",
      actionProperty: "assetCode",
      event: editAction,
      variant: "secondary",
      className: "mx-2 my-1",
      moduleName: "Asset",
      actionName: "Edit-Asset",
      icon: faPencilAlt,
    },
    {
      label: "View",
      actionProperty: "assetCode",
      event: detailsAction,
      variant: "info",
      className: "mx-2 my-1",
      moduleName: "Asset",
      actionName: "View-Asset",
      icon: faFileAlt,
    },
    {
      label: "Delete",
      actionProperty: "assetCode",
      event: deleteAction,
      variant: "danger",
      className: "mx-2 my-1",
      moduleName: "Asset",
      actionName: "Delete-Asset",
      icon: faTrashAlt,
    },
  ];

  const emptyConfig = {
    title: "No Data Found",
    description: "",
  };

  const filterFormConfig: FilterFormConfig = {
    controls: [
      {
        controlGroup: [
          {
            name: "townCouncil",
            placeholder: "Select Town Council *",
            type: "searchable-select",
            options: tcOptions,
            onChange: onChangeTC,
            required: true,
            isLoading: isLoadingTownCouncils,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "site",
            placeholder: "Select Site",
            type: "searchable-select",
            options: siteOptions,
            onChange: onChangeSite,
            required: false,
            isLoading: isLocationSitesByTCCode,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "block",
            placeholder: "Select Block",
            type: "searchable-select",
            options: blockOptions,
            onChange: onChangeBlock,
            required: false,
            isLoading: isLoadingBlocksBySiteCode,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "status",
            placeholder: "Select Status",
            type: "select",
            options: onlineOfflineOptions,
            required: false,
            isLoading: false,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "assetTypeId",
            placeholder: "Select Asset Type",
            type: "select",
            options: assetTypeOptions,
            onChange: onChangeAssetType,
            required: false,
            isLoading: false,
          },
        ],
      },
    ],
  };

  const validationSchema = yup.object().shape({
    townCouncil: yup.string().required("Town council is required"),
  });

  const [searchValue, setSearchValue] = useState("");

  const pollJobStatus = async (jobId: string): Promise<any> => {
    const maxAttempts = 240;

    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      // Check if upload was cancelled via AbortController
      if (abortControllerRef.current?.signal.aborted) {
        console.log("Upload cancelled, stopping polling");
        return null;
      }

      await new Promise<void>((resolve) => setTimeout(resolve, 5000));

      // Check again after the delay
      if (abortControllerRef.current?.signal.aborted) {
        console.log("Upload cancelled during polling delay");
        return null;
      }

      try {
        const response: any = await dispatch(getAssetUploadStatus({ jobId }));
        const data = response?.payload;

        if (data?.status === "Completed") return data?.result;
        if (data?.status === "Failed") {
          console.error("Asset upload job failed:", data?.error);
          showToast("error", data?.error ?? "Asset upload failed.");
          return null;
        }
        if (data?.status === "Processing") {
          const progress = data?.progress ?? 0;
          // setProgress(progress);
          dispatch(updateProgress(progress));
        }
      } catch (error) {
        console.error("Polling error:", error);
        // If aborted, return null silently
        if (abortControllerRef.current?.signal.aborted) {
          return null;
        }
      }
    }

    showToast("error", "Asset upload timed out. Please try again.");
    return null;
  };

  const showToast = (
    type: "success" | "warning" | "error",
    message: string,
  ) => {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
    });
  };

  const updateUploadProgress = (progressEvent: any) => {
    const { loaded, total } = progressEvent;
    if (total !== null && total !== undefined) {
      const percentCompleted = Math.round((loaded * 100) / total);
      // setProgress(percentCompleted);
      dispatch(updateProgress(percentCompleted));
    }
  };

  const buildUploadFormData = (
    uploadFile: File,
    isValidation: boolean,
    uploadMode: any,
    selectedDeviceCodes: any[] = [],
  ) => {
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("isValidation", isValidation ? "true" : "false");
    formData.append("uploadMode", uploadMode || "");

    for (let item of selectedDeviceCodes) {
      formData.append("deviceCodesForUpdate[]", item.value);
    }

    return formData;
  };

  const uploadAndPoll = async (formData: FormData) => {
    try {
      const uploadResponse: any = await dispatch(
        uploadAssetFile({
          formData,
          onUploadProgress: updateUploadProgress
        }),
      );

      const jobId =
        uploadResponse?.payload?.jobId ?? uploadResponse?.payload?.data?.jobId;
      if (!jobId) {
        // setProgress(0);
        dispatch(updateProgress(0));
        return null;
      }
      dispatch(setProcessing({ jobId }));

      return await pollJobStatus(jobId);
    } catch (error) {
      console.error("Error occurred while uploading and polling:", error);
      return null;
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      const isValid = await validateExcelFile(file);
      if (!isValid) {
        return;
      }

      // keep file and open modal for user to select import type / confirm
      setImportedFile(file);
      setImportType("incremental");
      setShowImportModal(true);
    }

    event.target.value = "";
  };

  const handleModalFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event?.target?.files && event?.target?.files?.length > 0) {
      const file = event.target.files[0];
      const isValid = await validateExcelFile(file);
      if (!isValid) return;

      setImportedFile(file);
      // keep modal open; user can confirm
    }

    if (event.target) event.target.value = "";
  };

  const removeModalFile = () => {
    setImportedFile(null);
  };

  const confirmImport = async () => {
    if (!importedFile) return;

    // sets the states of the progress toaster
    dispatch(startUpload({ fileName: importedFile.name, file: importedFile }));

    setShowImportModal(false);

    // Create new AbortController for this upload
    abortControllerRef.current = new AbortController();

    try {
      const formData = buildUploadFormData(importedFile, true, importType, []);
      const result = await uploadAndPoll(formData);
      dispatch(setUploadMode(importType))

      // Check if cancelled before processing result
      if (abortControllerRef?.current?.signal?.aborted) {
        console.log("Upload was cancelled, skipping result processing");
        return;
      }

      if (!result) {
        dispatch(closeToaster());
        return;
      }

      if (result?.data?.assetUploadValidationDetails?.length || result?.data?.warnings?.length) {
        if (
          abortControllerRef?.current === null ||
          abortControllerRef?.current?.signal?.aborted
        )
          return;

        const fileUploadResponse = _.cloneDeep(
          result?.data?.assetUploadValidationDetails,
        );

        const editableRows = _.cloneDeep(
          result?.data?.warnings,
        );

        const infoRows = _.cloneDeep(
          result?.data?.infos ?? [],
        );

        const _total = result?.numberOfRecords ?? 0;
        const _errors = result?.data?.assetUploadValidationDetails?.length ?? 0;
        const summary: UploadSummary = {
          added: _total > _errors ? _total - _errors : 0,
          total: _total,
          errors: _errors,
          message: result?.message ?? "",
          hasValidationErrors: true,
        };

        dispatch(
          openErrorModal({
            fileUploadResponse,
            editableRows,
            infoRows,
            modalNumberOfRecords: result?.numberOfRecords,
            toBeDeletedCount: result?.data?.uploadSummary?.toBeDeletedCount
          }),
        );

        dispatch(setComplete({ summary }));
      } else {
        if (
          abortControllerRef?.current === null ||
          abortControllerRef?.current?.signal?.aborted
        )
          return;

        if ([200, 201].includes(result?.status)) {
          showToast("success", result?.message);
        } else if (result?.status === 400) {
          showToast("warning", "Asset Upload failed, Please try again");

          onRefetchData();

          const summary: UploadSummary = {
            added: result.numberOfRecords ?? 0,
            total: result.numberOfRecords ?? 0,
            errors: 0,
            message: result.message ?? "",
            hasValidationErrors: false,
            resultStatus: [200, 201].includes(result.status),
          };

          dispatch(setFailed({ summary }));

          return;
        }
        else if (result?.message) {
          showToast("warning", result?.message);
        }

        onRefetchData();
        handleCloseModal(true);
        const summary: UploadSummary = {
          added: result.numberOfRecords ?? 0,
          total: result.numberOfRecords ?? 0,
          errors: 0,
          message: result.message ?? "",
          hasValidationErrors: false,
          resultStatus: [200, 201].includes(result.status),
        };

        dispatch(
          setComplete({
            summary,
            insertedAssetCodes: result?.data?.insertedAssetCodes ?? [],
            deletedAssetCodes: result?.data?.deletedAssetCodes ?? [],
          }),
        );
      }
    } catch (error: any) {
      if (error?.name === "AbortError" || error?.message?.includes("abort")) {
        console.log("Upload aborted by user");
        return;
      }

      dispatch(updateProgress(0));
      dispatch(setError());
      console.error("Error uploading file:", error);
    } finally {
      // Close modal after attempt
      setShowImportModal(false);
      setImportedFile(null);
    }
  };

  /*   useEffect(() => {
      if (progress > 0 && progress < 100) {
        setShowProgressModal(true);
      } else if (progress == 100) {
        setShowProgressModal(true);
  
        setTimeout(() => {
          setShowProgressModal(false);
        }, 500);
      } else {
        setShowProgressModal(false);
      }
    }, [progress]); */

  // Handle upload cancellation
  useEffect(() => {
    if (uploadState?.cancelled && abortControllerRef?.current) {
      console.log("Aborting upload operations");
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  }, [uploadState.cancelled]);

  useEffect(() => {
    if (!isEquipmentQuantityModalOpen) return;

    dispatch(
      getAssetsByLocationAndTypeSlice({
        assetTypeId: selectedEquipmentQuantityType,
        PageNumber: equipmentQuantityPageNo,
        pageSize,
        searchText: searchValue || null,
        SortBy: equipmentQuantitySortBy,
        SortDirection: equipmentQuantitySortDirection,
        tcCode: selectedTcCode,
        siteCode: selectedSiteCode,
        blockCode: selectedBlockCode,
      }),
    );
  }, [
    equipmentQuantityPageNo,
    selectedEquipmentQuantityType,
    selectedTcCode,
    selectedSiteCode,
    selectedBlockCode,
    isEquipmentQuantityModalOpen,
    equipmentQuantitySortBy,
    equipmentQuantitySortDirection,
  ]);

  const [filterUpdateCount, setFilterUpdateCount] = useState(0);

  const handleEquipmentChangePage = (page: number): void => {
    setEquipmentQuantityPageNo(page);
  };

  const handleEquipmentQuantityChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;

      setEquipmentQuantitySortBy(sortBy);
      setEquipmentQuantitySortDirection(sortDirection);

      const copyColumns: any = await TableSort(
        columnsEquipmentQuantity,
        equipmentQuantitySortBy,
      );
      setColumnsEquipmentQuantity(copyColumns);
    },
    [],
  );

  const handleSearch = (e?: React.FormEvent) => {
    if (e) e.preventDefault();

    setEquipmentQuantityPageNo(1);
    dispatch(
      getAssetsByLocationAndTypeSlice({
        assetTypeId: selectedEquipmentQuantityType,
        PageNumber: equipmentQuantityPageNo,
        pageSize,
        searchText: searchValue || null,
        SortBy: equipmentQuantitySortBy,
        SortDirection: equipmentQuantitySortDirection,
        tcCode: selectedTcCode,
        siteCode: selectedSiteCode,
      }),
    );
  };

  const handleClear = () => {
    setSearchValue("");
  };

  const handleKeyUp = (e: any) => {
    if (e.keyCode === 8 && !searchValue) {
      handleClear();
    }
  };

  const handleSearchRef = useRef(handleSearch);
  useEffect(() => {
    handleSearchRef.current = handleSearch;
  });

  const delayedSearchRef = useRef(
    _.debounce((e?: React.FormEvent) => handleSearchRef.current(e), 1000),
  );

  const isFirstSearchEffect = useRef(true);

  useEffect(() => {
    if (isFirstSearchEffect.current) {
      isFirstSearchEffect.current = false;
      return;
    }

    delayedSearchRef.current();
    return delayedSearchRef.current.cancel;
  }, [searchValue]);

  const getAssetModalHeaderTitle = () => {
    if (isEdit) return "";
    if (isDetails) return "";
    if (isDelete) return "Delete Asset";
    return "Add Asset";
  };

  return (
    <div>
      <AssetImportModalComponent
        showImportModal={showImportModal}
        setShowImportModal={setShowImportModal}
        setImportedFile={setImportedFile}
        importType={importType}
        setImportType={setImportType}
        importedFile={importedFile}
        removeModalFile={removeModalFile}
        confirmImport={confirmImport}
        handleModalFileChange={handleModalFileChange}
      />

      <AssetTaggingModalComponent
        showAssetTaggingModal={showAssetTaggingModal}
        setShowAssetTaggingModal={setShowAssetTaggingModal}
      />

      <div className="mt-2">
        <TitleComponent title="Overview" />

        <AssetStatisticsSection
          equipmentQuantityData={lightLocationDashboardSummary}
          isLoadingEquipmentQuantity={isLoadingLightLocationDashboardSummary}
          gatewaySummary={gatewaySummary}
          isLoadingGatewaySummary={isLoadingGatewaySummary}
          siteSummary={lightLocationDashboardSummary}
          isLoadingSiteSummary={isLoadingLightLocationDashboardSummary}
          lightSummary={lightSummary}
          isLoadingLightSummary={isLoadingLightSummary}
          modalHandler={healthStatusModalHandler}
        />
      </div>
      <div>
        <FilterFormComponent
          key={formFilterInitialValues?.townCouncil}
          formRef={formRef}
          initialValues={formFilterInitialValues}
          formConfig={filterFormConfig}
          actionConfig={filterActionConfig}
          validation={validationSchema}
          resetButton={reset}
          filterUpdateCount={filterUpdateCount}
        />
      </div>

      <div className="d-flex gap-3 justify-content-end table-generic-action table-toolbar">
        <SearchBarComponent
          placeholder="Search Asset"
          methodToDispatch={getAssetTableSearchStatus}
          getSearch={onSearch}
        />
        <HasPermission
          moduleName="Asset"
          actionName="Upload-Asset"
          isRoute={false}
        >
          <div className="d-flex justify-content-end table-generic-action button-group">

            <B2Button
              className="me-2 icon-text-btn"
              variant="primary"
              onClick={() => setShowAssetTaggingModal(true)}
            >
              <FontAwesomeIcon icon={faTag} className="" />
              <label htmlFor="tag" className="ms-2 cursor-pointer">
                Asset Tagging
              </label>
            </B2Button>

            <B2Button className="icon-text-btn" variant="primary">
              <FontAwesomeIcon icon={faUpload} className="" />
              <label htmlFor="upload" className="ms-2 cursor-pointer">
                Import Asset
                {' '}
                <input
                  accept={excelFileTypes}
                  id="upload"
                  type="file"
                  className="d-none"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    void handleFileChange(event);
                  }}
                />
              </label>
            </B2Button>

            <B2Button
              className="ms-2 icon-text-btn"
              variant="primary"
              onClick={() => onClickExport()}
            >
              {isLoadingAssetExport ? (
                <Spinner
                  animation="border"
                  variant="info"
                  size="sm"
                  className="me-2"
                />
              ) : (
                <FontAwesomeIcon icon={faDownload} className="me-2" />
              )}
              Export Asset
            </B2Button>
          </div>
        </HasPermission>
      </div>

      <div>
        <div className="my-3">
          <TableComponent
            tableHeaders={columns}
            emptyConfig={emptyConfig}
            data={data}
            totalNumberOfRecords={totalNumberOfRecords}
            pageSize={pageSize}
            current={current}
            onChangePage={onChangePage}
            actionConfig={actionConfig}
            onChangeSort={onChangeSort}
            isLoadingData={isLoading}
          />
        </div>
      </div>

      {/* modals */}

      {isModalOpen && (
        <ModalComponent
          isConformationModal={isDelete}
          showModal={isModalOpen}
          handleClose={() => handleCloseModal(true)}
          headerTitle={getAssetModalHeaderTitle()}
          actionConfig={modalActionConfig}
        >
          {isDelete && (
            <h5 className="text-center">
              Are you sure to <b className="text-danger">Delete</b>?
            </h5>
          )}
        </ModalComponent>
      )}
      {(isEdit || isDetails) && (
        <AssetEditTabComponent
          data={assetDetails}
          setIsEdit={setIsEdit}
          isDetails={isDetails}
          setIsDetails={setIsDetails}
          headerTitle={`Asset ${isEdit ? "Edit" : "Details"}`}
          setIsModalOpen={setIsModalOpen}
          onRefetchData={onRefetchData}
          isLoadingData={isLoadingAssetDetailsData}
        />
      )}

      {/* {showProgressModal && (
        <ProgressBarModalComponent
          showModal={showProgressModal}
          progress={progress}
        />
      )} */}

      {isEquipmentQuantityModalOpen && (
        <ModalComponent
          showModal={isEquipmentQuantityModalOpen}
          handleClose={() => handleCloseModal(false)}
          headerTitle={modalTitle}
          isViewMode={true}
          size="xl"
        >
          <div className="inside-table">
            <div className="d-flex justify-content-end align-items-end">
              <B2Form onSubmit={handleSearch}>
                <div
                  className=""
                  style={{
                    display: "flex",
                    width: "300px",
                    marginLeft: "48rem",
                    marginBottom: "20px",
                  }}
                >
                  <B2InputGroup>
                    <FormControl
                      style={{
                        borderRight: searchValue && "none",
                        height: "45px",
                        width: "250px",
                      }}
                      className="search-field"
                      placeholder={"Search Assets"}
                      value={searchValue}
                      onChange={(e: any) => setSearchValue(e.target.value)}
                      onKeyUp={handleKeyUp}
                    />

                    {/* <B2Input.Icon icon="bi-person" prefix /> */}

                    <B2InputGroup.Text>
                      <FontAwesomeIcon icon={faSearch} />
                    </B2InputGroup.Text>
                  </B2InputGroup>
                </div>
              </B2Form>
            </div>
            <TableComponent
              tableHeaders={
                selectedEquipmentQuantityType === 2
                  ? columnsForLuminaireQuantity
                  : columnsEquipmentQuantity
              }
              data={equipmentQuantityModalSearchedData?.data}
              pageSize={pageSize}
              current={equipmentQuantityPageNo}
              totalNumberOfRecords={
                equipmentQuantityModalSearchedData?.numberOfRecords
              }
              onChangePage={handleEquipmentChangePage}
              onChangeSort={handleEquipmentQuantityChangeSort}
              isLoadingData={isLoadingEquipmentQuantityModalData}
            />
          </div>
        </ModalComponent>
      )}

      {isTotalLightsFloorplanModalOpen && (
        <ModalComponent
          showModal={isTotalLightsFloorplanModalOpen}
          handleClose={() => handleCloseModal(false)}
          headerTitle={"Total Lights in Floor Plan"}
          isViewMode={true}
          size="xl"
        >
          <div className="inside-table">
            <div
              style={{ alignItems: "start !important" }}
              className="d-flex justify-content-center justify-content-xl-end gap-2"
            >
              <div className="d-flex flex-column flex-xl-row gap-2">
                <B2Form>
                  <div
                    style={{
                      display: "flex",
                      width: "300px",
                    }}
                  >
                    <B2InputGroup>
                      <B2Select
                        name={"floorplanStatus"}
                        onChange={async (selectedOption: any, event: any) =>
                          await handleFloorplanFilterChange(
                            "floorplanStatus",
                            selectedOption,
                            event,
                          )
                        }
                        value={floorplanStatus}
                        required={true}
                        defaultValue={floorplanStatus}
                        optionList={[
                          { value: "InFloorPlan", label: "In Floor Plan" },
                          { value: "OutFloorPlan", label: "Not In Floor Plan" },
                        ]}
                      />
                    </B2InputGroup>
                  </div>
                </B2Form>
              </div>
              <div
                style={{ height: "43.19px", alignItems: "center !important" }}
                className="d-flex"
              >
                <B2Button
                  className="ms-2 icon-text-btn"
                  variant="primary"
                  onClick={() => onClickFloorplanLightsExport()}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {isLoadingAssetExport ? (
                    <Spinner
                      animation="border"
                      variant="info"
                      size="sm"
                      className="me-2"
                    />
                  ) : (
                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                  )}
                  Export
                </B2Button>
              </div>
            </div>
            <div className="my-3">
              <TableComponent
                tableHeaders={floorplanLightsColumns}
                emptyConfig={emptyConfig}
                data={floorplanLightsAssets?.data || []}
                totalNumberOfRecords={
                  floorplanLightsAssets?.numberOfRecords || 0
                }
                pageSize={pageSize}
                current={floorplanLightsPageNumber}
                onChangePage={floorplanLightsHandleChangePage}
                // actionConfig={actionConfig}
                onChangeSort={floorplanLightsHandleChangeSort}
                isLoadingData={isLoadingfloorplanLightsAssets}
              />
            </div>
          </div>
        </ModalComponent>
      )}

      {/* Total Blocks Modal */}
      {isTotalBlocksModalOpen && (
        <ModalComponent
          showModal={isTotalBlocksModalOpen}
          handleClose={() => handleCloseModal(false)}
          headerTitle={"Total Blocks"}
          isViewMode={true}
          size="xl"
        >
          <div className="inside-table">
            <div
              style={{ alignItems: "start !important" }}
              className="d-flex justify-content-center justify-content-xl-end gap-2"
            >
              <div className="d-flex flex-column flex-xl-row gap-2">
                <B2Form>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "300px",
                    }}
                  >
                    <B2InputGroup>
                      <B2Select
                        name={"totalBlocksTCStatus"}
                        onChange={async (selectedOption: any, event: any) =>
                          await handleTotalBlocksFilterChange(
                            "totalBlocksTCStatus",
                            selectedOption,
                            event,
                          )
                        }
                        value={modalTownCouncil}
                        required={true}
                        defaultValue={modalTownCouncil}
                        optionList={[
                          { label: "Select Town Council", value: "" },
                          ...tcOptionsForTotalLightsFloorplan,
                        ]}
                        isInvalid={!!modalTownCouncilError}
                      />
                    </B2InputGroup>
                    {modalTownCouncilError && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {modalTownCouncilError}
                      </span>
                    )}
                  </div>
                </B2Form>
                <B2Form>
                  <div
                    style={{
                      display: "flex",
                      width: "300px",
                    }}
                  >
                    <B2InputGroup>
                      <B2Select
                        name={"totalBlocksSiteStatus"}
                        onChange={async (selectedOption: any, event: any) =>
                          await handleTotalBlocksFilterChange(
                            "totalBlocksSiteStatus",
                            selectedOption,
                            event,
                          )
                        }
                        value={modalSite}
                        required={true}
                        defaultValue={modalSite}
                        optionList={[
                          { label: "Select Site", value: "" },
                          ...modalSiteOptions,
                        ]}
                      />
                    </B2InputGroup>
                  </div>
                </B2Form>
                <B2Form>
                  <div
                    style={{
                      display: "flex",
                      width: "300px",
                    }}
                  >
                    <B2InputGroup>
                      <B2Select
                        name={"totalBlocksProjectCategory"}
                        onChange={async (selectedOption: any, event: any) =>
                          await handleTotalBlocksFilterChange(
                            "totalBlocksProjectCategory",
                            selectedOption,
                            event,
                          )
                        }
                        value={totalBlocksProjectCategory}
                        required={false}
                        defaultValue={totalBlocksProjectCategory}
                        optionList={[
                          { label: "Select Category", value: "" },
                          ...projectCategoryOptions,
                        ]}
                      />
                    </B2InputGroup>
                  </div>
                </B2Form>
              </div>
              <div
                style={{ height: "43.19px", alignItems: "center !important" }}
                className="d-flex"
              >
                <B2Button
                  className="ms-2 icon-text-btn"
                  variant="primary"
                  onClick={() => onClickTotalBlocksExport()}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {isLoadingBlocksExport ? (
                    <Spinner
                      animation="border"
                      variant="info"
                      size="sm"
                      className="me-2"
                    />
                  ) : (
                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                  )}
                  Export
                </B2Button>
              </div>
            </div>
            <div className="my-3">
              <TableComponent
                tableHeaders={totalBlocksColumns}
                emptyConfig={emptyConfig}
                data={totalBlocksData?.data || []}
                totalNumberOfRecords={totalBlocksData?.numberOfRecords || 0}
                pageSize={pageSize}
                current={totalBlocksPageNumber}
                onChangePage={totalBlocksHandleChangePage}
                onChangeSort={totalBlocksHandleChangeSort}
                isLoadingData={isLoadingTotalBlocks}
              />
            </div>
          </div>
        </ModalComponent>
      )}
    </div>
  );
};

export default AssetTableComponent;
